<template>
  <div class="body">
    <div class="content">
      <div id="header">
        <img class="logo" src="https://lp.tramontina.com.br/upload/app_teec/util/logo_guru.png" />
      </div>

      <br /><br />
      <Form v-if="hasChangePassword"></Form>
    </div>
  </div>
</template>

<script>
import Form from './components/Form'

export default {
  name: 'App',
  components: {
    Form,
  },
  data() {
    return {
      hasChangePassword: false,
    }
  },
  mounted: function() {
    if (window.location.href.includes('change-password')) {
      this.hasChangePassword = true
    } else {
      // this.hasChangePassword = true
      window.location.href = 'https://tramontina.com/guru'
    }
  },
}
</script>

<style>
.body {
  height: 100vh;
  position: relative;
}

.content {
  text-align: center;
  margin: 0;
  position: absolute;
  top: 40%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}

img {
  height: 15%;
  width: auto;
}

.logo {
  width: 60vw;
}

input {
  width: 150px;
  height: 30px;
  border-radius: 30px;
  border-color: rgb(225, 225, 225);
  outline: none;
  border-style: solid;
  padding: 5px;
}

.btn {
  width: 150px;
  height: 50px;
  border-radius: 30px;
  background-color: rgb(239, 127, 102);
  color: white;
  background: rgb(239, 127, 102);
  background: linear-gradient(90deg, rgb(239, 127, 102) 35%, rgb(243, 182, 123) 100%);
  outline: none;
  border-style: none;
  font-size: 20px;
}

p {
  color: red;
}

.guru {
  font-size: 40px;
}
</style>
